var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.247 9.01557C17.247 4.62142 13.5843 1.04053 9.05462 0.96876V0.96521C9.03704 0.96521 9.01972 0.967239 9.0024 0.967239C8.97353 0.966985 8.94493 0.96521 8.91606 0.96521V0.970789C8.49277 0.977636 8.06948 1.01086 7.65537 1.07856L7.96188 2.82882C8.3033 2.77303 8.65311 2.74513 9.00266 2.74235C12.5436 2.78748 15.41 5.58353 15.41 9.01557C15.41 12.4529 12.5349 15.2523 8.98639 15.2891C8.54762 15.2847 8.11015 15.2394 7.68503 15.1511L7.30005 16.8869C7.82831 16.9965 8.37153 17.0538 8.91606 17.0624V17.0659C8.93968 17.0659 8.96304 17.0644 8.98665 17.0642C9.00949 17.0644 9.03205 17.0659 9.05489 17.0659V17.0626C13.5843 16.9904 17.247 13.4097 17.247 9.01557Z",
    fill: "#51B37F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58361 9.5459L0.75293 9.69374C0.802003 10.2623 0.914321 10.8263 1.08595 11.3699L2.84288 10.8516C2.70931 10.4284 2.62192 9.98917 2.58361 9.5459Z",
    fill: "#51B37F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3827 12.0739L1.77954 12.9404C2.06637 13.4364 2.40962 13.9047 2.79932 14.3325L4.17811 13.1597C3.87422 12.826 3.60654 12.4606 3.3827 12.0739Z",
    fill: "#51B37F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39478 2.34145L5.42348 3.81225C5.80426 3.56348 6.21312 3.35377 6.63851 3.18868L5.95437 1.54138C5.40826 1.75313 4.88341 2.02218 4.39478 2.34145Z",
    fill: "#51B37F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09839 15.4868C4.57233 15.8264 5.08484 16.1178 5.62124 16.3523L6.3786 14.7352C5.96108 14.5524 5.56193 14.3257 5.1927 14.0609L4.09839 15.4868Z",
    fill: "#51B37F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93111 6.92063L1.19937 6.32825C1.00281 6.86458 0.8653 7.42374 0.790771 7.98975L2.61305 8.21417C2.67105 7.77318 2.77812 7.33803 2.93111 6.92063Z",
    fill: "#51B37F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37006 4.66995L3.04508 3.44031C2.63674 3.85137 2.27276 4.30504 1.96362 4.78863L3.5261 5.72183C3.76753 5.34449 4.05148 4.99074 4.37006 4.66995Z",
    fill: "#51B37F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9291 10.2276L9.4549 8.89048V5.84009H7.61792V10.0943L12.2495 11.8767L12.9291 10.2276Z",
    fill: "#51B37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarted);
export default __webpack_public_path__ + "static/media/started.c9962a2268b9164ce15dad7d488f3b51.svg";
export { ForwardRef as ReactComponent };